import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Loader from "../../common/Loader";
import SectionAppBar from "../../common/SectionAppBar";
import {
  getAllAttachmentsForStep,
  getAllCanvasesForStep,
  getAllFormsForStep,
  getAllRichTextsForStep,
  getAllStepsForSection,
  getAllSubstepsForStep,
  getAllVideosForStep,
} from "../../redux/stepSlice";
import SetTaskInfo from "../Tasks/SetTaskInfo";
import { getPages, renderPreview, renderVideo } from "./plugins/utils";
import {
  applyTransparency,
  calculateGroupHeight,
  calculateTextBlockWidth,
  estimateKonvaTextHeight,
  formatListContent,
  getTextStyle,
  hasNoteContent,
  hasTaskContent,
  hasUserContent,
  measureHtmlHeight,
  stripHtmlPreserveFormatting,
} from "../SectionElements/plugins/utils.js";
import RectangleElement from "../Canvas/components/rectangle/RectangleElement.jsx";
import ArrowElement from "../Canvas/components/arrow/ArrowElement.jsx";
import CircleElement from "../Canvas/components/circle/CircleElement.jsx";
import LineElement from "../Canvas/components/line/LineElement.jsx";
import CanvasImage from "../Canvas/components/canvas-core/CanvasImage.jsx";
import TextElement from "../Canvas/components/text/TextElement.jsx";
import DoubleSidedArrowElement from "../Canvas/components/arrow/DoubleSidedArrowElement.jsx";
import { getLastSibling, getSibling } from "../../redux/partSlice.js";
import CanvasDisplay from "../Canvas/components/canvas-core/CanvasDisplay.jsx";
import RenderHtml from "../../common/AppSpecificConpnents/PartsTable/RenderHtml.js";
const SelectedStepPage = () => {
  const {
    sectionId,
    elementId,
    partId,
    revisionId,
    stepId,
    substepId,
    partNumber,
    title,
    elementTitle,
    revision,
    stepTitle,
    section,
    siblingOrder,
    subsCount,
    richCount,
    attachmentCount,
    formCount,
    videoCount,
    canvasCount,
  } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const compareSiblingOrders = (a, b) => {
    const intA = parseInt(a, 10);
    const intB = parseInt(b, 10);
    return intA - intB;
  };

  // Scroll to top when component mounts
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const {
    stepsBySection,
    substepsByStep,
    richTexts,
    attachments,
    forms,
    videos,
    canvases,
    loading,
    error,
  } = useSelector((state) => state.step);
  const [stepCount, setStepCount] = useState(0);
  const [lastChildSibling, setLastChildSibling] = useState(1);
  const [lastSubstepSibling, setLastSubstepSibling] = useState(1);

  const [lastSibling, setLastSibling] = useState(null);
  const { sectionName, data, steps, partNumbers, hideSection } =
    location.state || {};

  const [counters, setCounters] = useState({
    richTextCounter: 1,
    attachmentCounter: 1,
    formCounter: 1,
    videoCounter: 1,
    canvasCounter: 1,
  });
  // State for loading and error messages
  const [isLoading, setIsLoading] = useState(true);
  const [errorMessage, setErrorMessage] = useState(null);
  let attachmentCounter = data?.attachmentCounter || 1;
  let canvasCounter = data?.canvasCounter || 1;
  let formCounter = data?.formCounter || 1;
  let richTextCounter = data?.richTextCounter || 1;
  let videoCounter = data?.videoCounter || 1;
  //   state for step data
  const [stepData, setStepData] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      setErrorMessage(null);
      try {
        const lastSibling = await dispatch(
          getSibling({
            type: "step",
            revisionId,
            partId,
            sectionId,
          })
        );
        const stepCount = await dispatch(
          getLastSibling({
            type: "step",
            revisionId,
            partId,
          })
        );
        const richTextCount = await dispatch(
          getLastSibling({
            type: "rich-text",

            revisionId,
            partId,
          })
        );
        const attachmentCount = await dispatch(
          getLastSibling({
            type: "attachment",

            revisionId,
            partId,
          })
        );

        const formCount = await dispatch(
          getLastSibling({
            type: "form",

            revisionId,
            partId,
          })
        );
        const videoCount = await dispatch(
          getLastSibling({
            type: "video",

            revisionId,
            partId,
          })
        );
        const canvasCount = await dispatch(
          getLastSibling({
            type: "canva",

            revisionId,
            partId,
          })
        );
        const lastChildSiblingOrder = await dispatch(
          getSibling({
            type: "child",
            sectionId,
            stepId,
            revisionId,
            partId,
            substepId,
          })
        );
        const lastSubstepSiblingOrder = await dispatch(
          getSibling({
            type: "substep",
            sectionId,
            stepId,
            revisionId,
            partId,
          })
        );
        setLastSibling(parseInt(lastSibling?.payload) + 1 || 0);
        setLastChildSibling(lastChildSiblingOrder?.payload || 0);
        setLastSubstepSibling(lastSubstepSiblingOrder?.payload || 0);

        setStepCount(stepCount?.payload || 0);
        setCounters({
          richTextCounter: parseInt(richTextCount.payload) || 0,
          attachmentCounter: parseInt(attachmentCount.payload) || 0,
          formCounter: parseInt(formCount.payload) || 0,
          videoCounter: parseInt(videoCount.payload) || 0,
          canvasCounter: parseInt(canvasCount.payload) || 0,
        });
        // First fetch the step data and update Redux store
        await dispatch(
          getAllStepsForSection({
            partId,
            revisionId,
            sectionId,
          })
        );

        // Then fetch all associated data
        await Promise.all([
          dispatch(
            getAllRichTextsForStep({
              partId,
              revisionId,
              sectionId,
              stepId,
              substepId: substepId === "null" ? null : substepId,
            })
          ),
          dispatch(
            getAllAttachmentsForStep({
              partId,
              revisionId,
              sectionId,
              stepId,
              substepId: substepId === "null" ? null : substepId,
            })
          ),
          dispatch(
            getAllFormsForStep({
              partId,
              revisionId,
              sectionId,
              stepId,
              substepId: substepId === "null" ? null : substepId,
            })
          ),
          dispatch(
            getAllVideosForStep({
              partId,
              revisionId,
              sectionId,
              stepId,
              substepId: substepId === "null" ? null : substepId,
            })
          ),
          dispatch(
            getAllCanvasesForStep({
              partId,
              revisionId,
              sectionId,
              stepId,
              substepId: substepId === "null" ? null : substepId,
            })
          ),
          dispatch(
            getAllSubstepsForStep({
              partId,
              revisionId,
              sectionId,
              stepId,
            })
          ),
        ]);
      } catch (err) {
        setErrorMessage(
          err.message || "Failed to load step data. Please try again."
        );
      } finally {
        setIsLoading(false);
      }
    };

    // Check if we should refresh data (coming back from edit page)
    const shouldRefreshData = location.state?.shouldRefreshData;

    if (partId && revisionId && sectionId && stepId) {
      fetchData();

      // Clear the refresh flag from location state after fetching
      if (shouldRefreshData) {
        navigate(location.pathname, { replace: true }); // Replace current history entry without the state
      }
    }
  }, [
    dispatch,
    partId,
    revisionId,
    sectionId,
    stepId,
    substepId,
    location.state?.shouldRefreshData,
  ]);

  // Get step data from Redux store
  const step = stepsBySection[sectionId]?.find(
    (s) => s.step_tree_node_id === stepId
  );

  if (step) {
    SetTaskInfo(step.step_tree_node_id, step.procedure_tree?.tree_node_id);
  }

  // Helper function to safely access nested data
  const getNodeData = (data, id) => {
    if (!data || !id) return [];
    return (data[id] || []).filter((item) => !item.substep_id_ref);
  };

  // Helper function to get video data
  const getVideoData = (data, id) => {
    if (!data || !id) return [];
    const videos = data[id] || [];
    return videos.filter((video) => !video.substep_id_ref);
  };

  if (isLoading) {
    return <Loader text="Loading step data..." />;
  }

  if (errorMessage) {
    return (
      <div style={{ padding: "20px", textAlign: "center" }}>
        <div className="alert alert-danger" role="alert">
          <h4 className="alert-heading">Error Loading Step Data</h4>
          <p>{errorMessage}</p>
          <hr />
          <p className="mb-0">
            <button
              className="btn btn-primary"
              onClick={() => window.location.reload()}
            >
              Retry
            </button>
          </p>
        </div>
      </div>
    );
  }

  if (!step) {
    return <Loader text="Loading step data..." />;
  }

  return (
    <div>
      <SectionAppBar
        isStep={true}
        stepId={stepId}
        richCount={counters.richTextCounter}
        subsCount={subsCount}
        attachmentCount={counters.attachmentCounter}
        videoCount={counters.videoCounter}
        formCount={counters.formCounter}
        canvasCount={counters.canvasCounter}
        title={title}
        path={`/add-section`}
        partId={partId}
        revisionId={revisionId}
        sectionId={sectionId}
        subheading={""}
        partNumber={partNumber}
        revision={revision}
        section={section}
        stepTitle={title}
        stepCount={data?.stepCounter || stepCount || step?.stepCount}
        elementType="Step"
        siblingOrder={
          siblingOrder.includes(",")
            ? siblingOrder.split(",")[0].trim()
            : siblingOrder
        }
        isSelectedPage={true}
        partType={data?.type}
        status={data?.status}
        description={data?.description}
        steps={steps}
        partNumbers={data?.partNumbers}
        data={data}
        fromSectionId={sectionId}
        fromTreeId={data?.fromTreeId}
        fromSiblingOrder={data?.fromSiblingOrder}
        fromStepTreeId={data?.fromStepTreeId}
        fromStepSiblingOrder={data?.fromStepSiblingOrder}
        lastChildSibling={parseInt(lastChildSibling || 0) + 1 || 1}
        lastSubstepSibling={parseInt(lastSubstepSibling || 0) + 1 || 1}
        move_rev_node_info={data?.move_rev_node_info}
        item_code_type={data?.item_code_type}
      />
      <div style={{ padding: "20px" }}>
        {/* {hideSection ? null : (
          <>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
                marginBottom: "20px",
                paddingBottom: "20px",
                borderBottom: "3px double #e0e0e0",
                justifyContent: "space-between",
              }}
            >
              <div
                style={{ display: "flex", alignItems: "center", gap: "8px" }}
              >
                <input type="checkbox" checked={true} disabled={true} />
                <h2 style={{ margin: 0, fontSize: "23px" }}>{section}</h2>
              </div>
            </div>
            <div style={{ marginBottom: "20px" }}>
              <h3
                style={{
                  margin: 0,
                  color: "#666",
                  fontWeight: "normal",
                  fontSize: "14px",
                }}
              >
                {sectionName}
              </h3>
            </div>
          </>
        )} */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "8px",
            marginBottom: "20px",
            paddingBottom: "20px",
            borderBottom: "3px double #e0e0e0",
            justifyContent: "space-between",
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <input type="checkbox" defaultChecked={true} readOnly />
            <h2 style={{ margin: 0, fontSize: "23px" }}>{title}</h2>
          </div>
          <div
            style={{ color: "#888", fontSize: "14px", fontWeight: "normal" }}
          >
            {section} &gt; {title}
          </div>
        </div>

        {/* Step Description */}
        <p style={{ marginLeft: "5px" }}>{step?.short_description}</p>

        {/* Step Details */}
        {step?.step_details && step.step_details.length > 0 && (
          <div style={{ marginLeft: "5px" }}>
            {structuredClone(step.step_details)
              .sort((a, b) => {
                // Check if orders field exists
                const hasOrdersA = a.hasOwnProperty('orders');
                const hasOrdersB = b.hasOwnProperty('orders');
                
                // If both have orders, sort by orders first, then created_at
                if (hasOrdersA && hasOrdersB) {
                  const orderA = parseInt(a.orders ?? 0, 10);
                  const orderB = parseInt(b.orders ?? 0, 10);
                  if (orderA !== orderB) return orderA - orderB;
                  // Fallback to created_at if orders are equal
                  return new Date(a.created_at || 0) - new Date(b.created_at || 0);
                }
                
                // If orders field is missing, sort by created_at in ascending order
                return new Date(a.created_at || 0) - new Date(b.created_at || 0);
              })
              .map((myStep, index) => {
                const partNumber = myStep.part_info?.part_number || "";
                const description = myStep.part_info?.description || "";
                const qtyText =
                  myStep.qty && myStep.qty != 0 ? `Qty ${myStep.qty}` : "";
                const partText = partNumber ? ` (${partNumber})` : "";
                return (
                  // <span key={`step-detail-${index}`}>
                  //   {`${myStep.action} ${partText} ${description} ${qtyText} `.trim()}
                  // </span>
                  <span key={`step-detail-${index}`}>
                    {myStep.action && <>{myStep.action} </>}
                    {partText && <>{partText} </>}
                    {description && (
                      <>
                        <RenderHtml content={description} />{" "}
                      </>
                    )}
                    {qtyText && <>{qtyText}</>}&nbsp;
                  </span>
                );
              })}
          </div>
        )}

        {/* Parts Required Table */}
        {step?.parts_required && (
          <div style={{ marginLeft: "5px", marginTop: "10px" }}>
            <h4>{step?.bom_table_title_info?.category_name || ""}</h4>
            <table className="table">
              <thead>
                <tr>
                  <th>Type</th>
                  <th>
                    {step?.part_number_column_title_ref_info?.category_name}
                  </th>
                  <th>Description</th>
                  <th>Qty Per</th>
                  <th>Unit</th>
                </tr>
              </thead>
              <tbody>
                {[...step.parts_required]
                  .sort((a, b) => {
                    // 1. Sort by Type orders field (ascending numerically)
                    const orderA = parseInt(
                      a.part_info?.type_info?.orders || 999999,
                      10
                    );
                    const orderB = parseInt(
                      b.part_info?.type_info?.orders || 999999,
                      10
                    );

                    if (orderA !== orderB) return orderA - orderB;

                    // 2. If type orders are equal, sort by part_number (numbers first, then alphabet)
                    const partNumberA = a.part_info?.part_number || "";
                    const partNumberB = b.part_info?.part_number || "";

                    // Helper to split into numeric and alpha
                    const splitPart = (str) => {
                      const match = str.match(/^(\d+)?([A-Za-z].*)?$/);
                      if (!match) return { num: NaN, rest: str };
                      return {
                        num: match[1] ? parseInt(match[1], 10) : NaN,
                        rest: match[2] || str,
                      };
                    };
                    const aSplit = splitPart(partNumberA);
                    const bSplit = splitPart(partNumberB);

                    // Numbers first
                    if (!isNaN(aSplit.num) && isNaN(bSplit.num)) return -1;
                    if (isNaN(aSplit.num) && !isNaN(bSplit.num)) return 1;
                    if (!isNaN(aSplit.num) && !isNaN(bSplit.num)) {
                      if (aSplit.num !== bSplit.num)
                        return aSplit.num - bSplit.num;
                      // If numbers equal, compare rest
                      return aSplit.rest.localeCompare(bSplit.rest);
                    }
                    // Both are alpha or both are NaN
                    return partNumberA.localeCompare(partNumberB);
                  })
                  .map((row, idx) => (
                    <tr key={`part-required-${idx}`}>
                      <td>{row.part_info?.type_info?.name || ""}</td>
                      <td>{row.part_info?.part_number || ""}</td>
                      <td>
                        <RenderHtml content={row.part_info?.description} />
                      </td>
                      <td>{row.qty === 0 ? "" : row.qty}</td>
                      <td>{row.part_info?.unit_info?.unit_name || ""}</td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        )}

        {/* Step-level Rich Texts */}
        {data?.filteredItems?.map((item, childIndex) => {
          if (item.substep_id_ref || item.sub_step_tree_node_id) return null;
          switch (item.type) {
            case "richText": {
              const globalRichTextNumber = richTextCounter++; // ✅ use then increment
              // render richText block here
              const label = <h2>Rich Text {globalRichTextNumber}</h2>;

              return (
                <div
                  key={item.rich_text_tree_node_id}
                  style={{ marginTop: "20px" }}
                >
                  <label
                    style={{
                      display: "flex",
                      gap: "6px",
                      cursor: "pointer",
                    }}
                  >
                    <input type="checkbox" disabled={true} checked={true} />
                    {label}
                  </label>

                  <div
                    style={{
                      marginLeft: "5px",
                      marginTop: "-10px",
                    }}
                  >
                    {item.short_description}
                  </div>
                  <div
                    style={{
                      marginLeft: "4px",
                      marginTop: "5px",
                    }}
                  >
                    {item.category_data
                      ? item.category_data?.category_name
                      : item.category_info?.category_name}
                  </div>
                  <div
                    style={{
                      fontSize: "14px",
                      marginLeft: "4px",
                      marginTop: "5px",
                    }}
                  >
                    <div
                      className="rich-text-content-display"
                      style={{ marginTop: "-6px", clear: "both" }}
                      dangerouslySetInnerHTML={{
                        __html: item.rich_text_content,
                      }}
                    />
                  </div>
                </div>
              );
            }
            case "video": {
              const globalVideoNumber = videoCounter++; // ✅ use then increment
              const label = <h2>Video {globalVideoNumber}</h2>;

              return (
                <div key={label} style={{ marginTop: "20px" }}>
                  <label
                    style={{
                      display: "flex",
                      gap: "6px",
                      cursor: "pointer",
                    }}
                  >
                    <input type="checkbox" disabled={true} checked={true} />
                    {label}
                  </label>

                  {renderVideo(item)}

                  <div>{item.video_url}</div>

                  <div>{item.short_description}</div>
                </div>
              );
            }

            case "form": {
              const globalFormNumber = formCounter++; // ✅ use then increment
              const label = <h2>Form {globalFormNumber}</h2>;
              // render form block here
              return (
                <div key={label}>
                  <label
                    style={{
                      display: "flex",
                      gap: "6px",
                      cursor: "pointer",
                      marginTop: "20px",
                    }}
                  >
                    <input type="checkbox" disabled={true} checked={true} />

                    {label}
                  </label>
                  <div>{item.short_description}</div>
                </div>
              );
            }
            case "canvas": {
              const globalCanvasNumber = canvasCounter++; // ✅ use then increment
              const label = <h3>Canvas {globalCanvasNumber}</h3>;
              const shapes = item.shapes || [];
              const pages = getPages(item);

              return (
                <div key={label} style={{ marginTop: "40px" }}>
                  <label
                    style={{
                      display: "flex",
                      gap: "6px",
                      cursor: "pointer",
                    }}
                  >
                    <input type="checkbox" disabled={true} checked={true} />

                    <h2>{label}</h2>
                  </label>

                  <div>{item.short_description}</div>

                  {/* Display all pages vertically */}
                  <CanvasDisplay
                    pages={pages}
                    hasUserContent={hasUserContent}
                    getTextStyle={getTextStyle}
                    stripHtmlPreserveFormatting={stripHtmlPreserveFormatting}
                    estimateKonvaTextHeight={estimateKonvaTextHeight}
                    formatListContent={formatListContent}
                    hasNoteContent={hasNoteContent}
                    hasTaskContent={hasTaskContent}
                    calculateGroupHeight={calculateGroupHeight}
                    calculateTextBlockWidth={calculateTextBlockWidth}
                  />
                </div>
              );
            }
            case "attachment": {
              const attachmentList = item.attachments || [];
              if (attachmentList.length === 0) return null;

              //  const globalAttachmentNumber =
              //           attachmentCounter++; // ✅ use then increment
              const globalAttachmentNumber = attachmentCounter++; // ✅ Increment here per attachment
              const label = <h2>Attachment {globalAttachmentNumber}</h2>;

              return (
                <div key={item}>
                  <label
                    style={{
                      display: "flex",
                      gap: "6px",
                      cursor: "pointer",
                      marginTop: "20px",
                    }}
                  >
                    <input type="checkbox" disabled={true} checked={true} />
                    {label}
                  </label>
                  <div>{item.short_description}</div>
                  {attachmentList.map((attachment, i) => (
                    <div key={i} style={{ marginLeft: "20px" }}>
                      {renderPreview(attachment)}
                    </div>
                  ))}
                </div>
              );
            }
            default:
              return null;
          }
        })}

        {/* Substeps */}
        {(substepsByStep[stepId] || []).map((substep, substepIndex) => {
          const substepId = substep.sub_step_tree_node_id;
          const combinedItems = [
            ...(richTexts[substepId] || []).map((item) => ({
              ...item,
              type: "richText",
            })),
            ...(forms[substepId] || []).map((item) => ({
              ...item,
              type: "form",
            })),
            ...(attachments[substepId] || []).map((item) => ({
              ...item,
              type: "attachment",
            })),
            ...(canvases[substepId] || []).map((item) => ({
              ...item,
              type: "canvas",
            })),
            ...(videos[substepId] || []).map((item) => ({
              ...item,
              type: "video",
            })),
          ]; // Filter out substeps or unwanted items (same as your current filter)
          const filteredItems = combinedItems;

          filteredItems.sort((a, b) => {
            const orderA = a.sibling_order || a.procedure_tree?.sibling_order;
            const orderB = b.sibling_order || b.procedure_tree?.sibling_order;

            const orderCompare = compareSiblingOrders(orderA, orderB);
            if (orderCompare !== 0) return orderCompare;

            // Fallback: compare created_at
            const dateA = new Date(a.created_at);
            const dateB = new Date(b.created_at);
            return dateB - dateA; // latest comes first
          });

          // Final substep label like Substep 5A
          const substepLetter = String.fromCharCode(65 + substepIndex); // A, B, C, ...

          const globalSubstepLabel = `Substep ${
            data?.stepNumber || 1
          }${substepLetter}`;

          return (
            <div key={substepId} style={{ marginTop: "20px" }}>
              <div>
                <label
                  style={{
                    display: "flex",
                    gap: "8px",
                    cursor: "pointer",
                  }}
                >
                  <input type="checkbox" disabled={true} checked={true} />
                  <h2 style={{ margin: 0 }}>{globalSubstepLabel}</h2>
                </label>

                <div>{substep.short_description}</div>
              </div>

              {/* Substep Content */}
              {filteredItems.map((item, childIndex) => {
                switch (item.type) {
                  case "richText": {
                    const globalRichTextNumber = richTextCounter++; // ✅ use then increment
                    // render richText block here
                    const label = <h2>Rich Text {globalRichTextNumber}</h2>;

                    return (
                      <div
                        key={item.rich_text_tree_node_id}
                        style={{ marginTop: "20px" }}
                      >
                        <label
                          style={{
                            display: "flex",
                            gap: "6px",
                            cursor: "pointer",
                          }}
                        >
                          <input
                            type="checkbox"
                            disabled={true}
                            checked={true}
                          />
                          {label}
                        </label>

                        <div
                          style={{
                            marginLeft: "5px",
                            marginTop: "-10px",
                          }}
                        >
                          {item.short_description}
                        </div>
                        <div
                          style={{
                            marginLeft: "4px",
                            marginTop: "5px",
                          }}
                        >
                          {item.category_data
                            ? item.category_data?.category_name
                            : item.category_info?.category_name}
                        </div>
                        <div
                          style={{
                            fontSize: "14px",
                            marginLeft: "4px",
                            marginTop: "5px",
                          }}
                        >
                          <div
                            style={{ marginTop: "-6px" }}
                            dangerouslySetInnerHTML={{
                              __html: item.rich_text_content,
                            }}
                          />
                        </div>
                      </div>
                    );
                  }
                  case "video": {
                    const globalVideoNumber = videoCounter++; // ✅ use then increment
                    const label = <h2>Video {globalVideoNumber}</h2>;

                    return (
                      <div key={label} style={{ marginTop: "20px" }}>
                        <label
                          style={{
                            display: "flex",
                            gap: "6px",
                            cursor: "pointer",
                          }}
                        >
                          <input
                            type="checkbox"
                            disabled={true}
                            checked={true}
                          />
                          {label}
                        </label>

                        {renderVideo(item)}

                        <div>{item.video_url}</div>

                        <div>{item.short_description}</div>
                      </div>
                    );
                  }

                  case "form": {
                    const globalFormNumber = formCounter++; // ✅ use then increment
                    const label = <h2>Form {globalFormNumber}</h2>;
                    // render form block here
                    return (
                      <div key={label}>
                        <label
                          style={{
                            display: "flex",
                            gap: "6px",
                            cursor: "pointer",
                            marginTop: "20px",
                          }}
                        >
                          <input
                            type="checkbox"
                            disabled={true}
                            checked={true}
                          />

                          {label}
                        </label>
                        <div>{item.short_description}</div>
                      </div>
                    );
                  }
                  case "canvas": {
                    const globalCanvasNumber = canvasCounter++; // ✅ use then increment
                    const label = <h3>Canvas {globalCanvasNumber}</h3>;
                    const shapes = item.shapes || [];
                    const pages = getPages(item);

                    return (
                      <div key={label} style={{ marginTop: "40px" }}>
                        <label
                          style={{
                            display: "flex",
                            gap: "6px",
                            cursor: "pointer",
                          }}
                        >
                          <input
                            type="checkbox"
                            disabled={true}
                            checked={true}
                          />

                          <h2>{label}</h2>
                        </label>

                        <div>{item.short_description}</div>
                        {/* Display all pages vertically */}
                        <CanvasDisplay
                          pages={pages}
                          hasUserContent={hasUserContent}
                          getTextStyle={getTextStyle}
                          stripHtmlPreserveFormatting={
                            stripHtmlPreserveFormatting
                          }
                          estimateKonvaTextHeight={estimateKonvaTextHeight}
                          formatListContent={formatListContent}
                          hasNoteContent={hasNoteContent}
                          hasTaskContent={hasTaskContent}
                          calculateGroupHeight={calculateGroupHeight}
                          calculateTextBlockWidth={calculateTextBlockWidth}
                        />
                      </div>
                    );
                  }
                  case "attachment": {
                    const attachmentList = item.attachments || [];
                    if (attachmentList.length === 0) return null;

                    //  const globalAttachmentNumber =
                    //           attachmentCounter++; // ✅ use then increment
                    const globalAttachmentNumber = attachmentCounter++; // ✅ Increment here per attachment
                    const label = <h2>Attachment {globalAttachmentNumber}</h2>;

                    return (
                      <div key={item}>
                        <label
                          style={{
                            display: "flex",
                            gap: "6px",
                            cursor: "pointer",
                            marginTop: "20px",
                          }}
                        >
                          <input
                            type="checkbox"
                            disabled={true}
                            checked={true}
                          />
                          {label}
                        </label>
                        <div>{item.short_description}</div>
                        {attachmentList.map((attachment, i) => (
                          <div key={i} style={{ marginLeft: "20px" }}>
                            {renderPreview(attachment)}
                          </div>
                        ))}
                      </div>
                    );
                  }
                  default:
                    return null;
                }
              })}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default SelectedStepPage;
